"use strict";
angular.module("channelHotSpotsModule", [
    "channelHotSpotsRouterModule", //渠道热点路由
    "newsPaperChannelHotSpotsModule", //纸媒热点
    "websiteChannelHotSpotsModule", //网站热点
    "weiboChannelHotSpotsModule", //微博热点
    "weiboSecondChannelHotSpotsModule", // 微博二
    "weixinChannelHotSpotsModule", //微信热点
    "appChannelHotSpotsModule",//客户端热点
    "searchChannelHotSpotsModule"//客户端热点
]).
controller("channelHotSpotsCtrl", [function() {

}]);